import {User} from "../../models/user";
import { AuthTokenProvider } from "../../services/sp-authentication/session-provider.service";
import { environment } from "src/environments/environment";

export class Session {
  protected _authTokenProvider: AuthTokenProvider;
  private _impersonation: boolean;
  private _user: User;
  private _fronteggImpersonation: boolean;

  constructor(authTokenProvider: AuthTokenProvider, user: User, impersonation: boolean, fronteggImpersonation: boolean = false) {
    this._authTokenProvider = authTokenProvider;
    this._impersonation = impersonation;
    this._user = user;
    this._fronteggImpersonation = fronteggImpersonation;
  }

  async hasPermission(permission: string): Promise<boolean> {
    let permissions = this.user.permissions;
    let keys = permissions.map(p => p.key);

    if(!keys.includes(permission)) {
      return keys.includes('*');
    } else {
      let basePerm = permissions.find(perm => perm.key == permission);
      return basePerm.access;
    }
  }

  async logout() {
    await this.authTokenProvider.logout();
  }

  get authTokenProvider(): AuthTokenProvider { return this._authTokenProvider; }
  get impersonation(): boolean { return this._impersonation; }
  /** A staff member signed in as this user through Frontegg (the platform's impersonation), not Soprism's own. */
  get fronteggImpersonation(): boolean { return this._fronteggImpersonation; }
  get user(): User { return this._user; }
}
